export interface PharmacyDispositionCode {
  code: string;
  text: string;
  priority: number;
  colour: "red" | "amber" | "green";
  adcMetric: string;
  deadlineHours: number | null;
}

export const PHARMACY_DISPOSITION_CODES: readonly PharmacyDispositionCode[] = [
  { code: "Dx97", text: "Emergency Contraception required within 2 hours",  priority: 1, colour: "red",   adcMetric: "E08", deadlineHours: 2    },
  { code: "Dx85", text: "Repeat prescription required within 2 hours",      priority: 1, colour: "red",   adcMetric: "E14", deadlineHours: 2    },
  { code: "Dx80", text: "Repeat prescription required within 6 hours",      priority: 2, colour: "amber", adcMetric: "E14", deadlineHours: 6    },
  { code: "Dx98", text: "Emergency Contraception required within 12 hours", priority: 3, colour: "amber", adcMetric: "E08", deadlineHours: 12   },
  { code: "Dx86", text: "Repeat prescription required within 12 hours",     priority: 3, colour: "amber", adcMetric: "E14", deadlineHours: 12   },
  { code: "Dx28", text: "Contact Pharmacist within 24 hours",               priority: 4, colour: "amber", adcMetric: "E13", deadlineHours: 24   },
  { code: "Dx87", text: "Repeat prescription required within 24 hours",     priority: 4, colour: "amber", adcMetric: "E14", deadlineHours: 24   },
  { code: "Dx29", text: "Contact Pharmacist next working day",              priority: 5, colour: "green", adcMetric: "E13", deadlineHours: null },
];

export const DISPOSITION_COLOUR_TOKENS = {
  red:   { dot: "bg-red-500",   badge: "bg-red-100 text-red-800",     label: "Within 2 hours"   },
  amber: { dot: "bg-amber-400", badge: "bg-amber-100 text-amber-800", label: "Within 24 hours"  },
  green: { dot: "bg-green-500", badge: "bg-green-100 text-green-700", label: "Next working day" },
} as const;

export function findPharmacyDisposition(code: string): PharmacyDispositionCode | undefined {
  return PHARMACY_DISPOSITION_CODES.find((d) => d.code === code);
}
